import React, { useCallback, useState } from 'react';
import { useIntl } from 'react-intl';
import { FieldTextInput, OutsideClickHandler } from '../../../../components';
import css from './CategorySpecializationField.module.css';
import IconCollection from '../../../../components/IconCollection/IconCollection';
import { required } from '../../../../util/validators';
import { stringToKey } from '../../../../util/data';
import { TRAVEL_TYPES } from '../../../../util/types';

const SERVICE_OFFERED_MAX_LENGTH = 150;

const CategorySpecializationField = ({
  values,
  formId,
  formApi,
  servicesOffered,
  setServicesOffered,
}) => {
  const intl = useIntl();
  const [isOpen, setIsOpen] = useState(false);

  const toggleDropdown = () => setIsOpen(prev => !prev);

  return (
    <div className={css.fieldContainer}>
      <label>{intl.formatMessage({ id: 'EditListingDetailsForm.services' })}</label>
      <OutsideClickHandler
        className={css.destinationsContainer}
        onOutsideClick={() => setIsOpen(false)}
      >
        <div className={css.destinationsField}>
          <FieldTextInput
            id={`${formId}service`}
            name="service"
            className={css.titleInput}
            type="text"
            label={''}
            onClick={toggleDropdown}
          />
          {/* <span className={css.dropdownArrow}>
            {isOpen ? (
              <IconCollection className={css.openedSvg} icon="icon-arrow-up-black" />
            ) : (
              <IconCollection icon="icon-arrow-down-black" />
            )}
          </span> */}
          <div
            onClick={() => {
              setIsOpen(false);
              if (!!values.service && servicesOffered?.length < 5) {
                setServicesOffered(prev => {
                  const payload = [...prev, values.service];
                  formApi.batch(() => {
                    formApi.change('services', payload);
                    formApi.change('service', '');
                  });
                  return payload;
                });
              }
            }}
            className={css.addButton}
          >
            <IconCollection icon={'iconPlusWithDarkCircle'} />
          </div>
        </div>

        {isOpen && (
          <div className={css.dropdownMenu}>
            {TRAVEL_TYPES.map(
              ({ label }, index) =>
                !values?.services?.includes(label) && (
                  <div
                    key={`${label}-${index}`}
                    className={css.dropdownCategory}
                    onClick={() => {
                      if (servicesOffered?.length < 5) {
                        setServicesOffered(prev => {
                          const payload = [...new Set([...prev, label])];
                          formApi.batch(() => {
                            formApi.change('services', payload);
                            formApi.change('service', '');
                          });
                          return payload;
                        });
                      }
                      setIsOpen(false);
                    }}
                  >
                    {label}
                  </div>
                )
            )}
          </div>
        )}
      </OutsideClickHandler>

      <div className={css.destinationsList}>
        {servicesOffered.map((service, index) => (
          <div key={`service-${index}-${service}`} className={css.destinationItem}>
            <div className={css.destinationItemText}>
              {' '}
              <span className={css.destinationItemTextIcon}></span> {service}
            </div>{' '}
            <div
              onClick={() =>
                setServicesOffered(prev => {
                  const payload = prev.filter(elm => elm !== service);
                  formApi.change('services', payload);
                  formApi.change(stringToKey(service), null);
                  return payload;
                })
              }
            >
              <IconCollection icon={'iconDarkCrossWithDarkBorder'} />
            </div>
          </div>
        ))}
      </div>

      {servicesOffered.map((service, index) => {
        const serviceKey = stringToKey(service);
        return (
          <div key={`textarea-${index}-${serviceKey}`} className={css.textareaInputWrapper}>
            <FieldTextInput
              id={`${formId}${serviceKey}`}
              name={serviceKey}
              className={css.textAreaInput}
              type="textarea"
              label={service}
              maxLength={SERVICE_OFFERED_MAX_LENGTH}
              placeholder={intl.formatMessage({
                id: 'EditListingDetailsForm.budgetPlaceholder',
              })}
            />
            <p className={css.destinationCharCount}>
              {values?.[`${serviceKey}`]?.length || 0}/{SERVICE_OFFERED_MAX_LENGTH}
            </p>
          </div>
        );
      })}
    </div>
  );
};

export default CategorySpecializationField;
